module.exports = __webpack_public_path__ + "img/icon-2.07b2b901.svg";